import { all, put, call, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import authClient from '../authClient';
import { showNotification } from 'admin-on-rest';

import { USER_REGISTER, USER_FORGOTPASS } from '../AuthActionAddons';
import { USER_LOGIN_LOADING,USER_LOGIN_SUCCESS,USER_LOGIN_FAILURE} from 'admin-on-rest';

export const AUTH_REGISTER = 'AUTH_REGISTER';
export const AUTH_FORGOTPASS = 'AUTH_FORGOTPASS';

function* handleAuthAddon(action) {
	const { type, payload, error, meta } = action;
	switch (type) {
		case USER_REGISTER: {
			try {
				yield put({ type: USER_LOGIN_LOADING });
				const authPayload = yield call(
					authClient,
					AUTH_REGISTER,
					payload
				);
				yield put({
					type: USER_LOGIN_SUCCESS,
					payload: authPayload,
				});
				yield put(push(meta.pathName || '/'));
			} catch (e) {
				yield put({
					type: USER_LOGIN_FAILURE,
					error: e,
					meta: { auth: true },
				});
				const errorMessage =
					typeof e === 'string'
						? e
						: typeof e === 'undefined' || !e.message
						  ? 'aor.auth.sign_in_error'
						  : e.message;
				yield put(showNotification(errorMessage, 'warning'));
			}
			break;
		}           
		case USER_FORGOTPASS: {
			try {
				//yield put({ type: USER_LOGIN_LOADING });
				yield call(
					authClient,
					AUTH_FORGOTPASS,
					payload
				);
				yield put(showNotification('cloudhints.pass_send','warning'));
			} catch (e) {
				yield put({
					type: USER_LOGIN_FAILURE,
					error: e,
					meta: { auth: true },
				});
				const errorMessage =
					typeof e === 'string'
						? e
						: typeof e === 'undefined' || !e.message
						  ? 'aor.auth.sign_in_error'
						  : e.message;
				yield put(showNotification(errorMessage, 'warning'));
			}
			break;
		}  
		default : {
			yield put(showNotification('cloudhints.unkown_request','warning'));
		}
	}
}

export default function* authAddonSaga() {
	yield all([
		takeEvery(action => action.meta && action.meta.authAddon, handleAuthAddon)
	]);   
};



// WEBPACK FOOTER //
// ./src/saga/authAddonSaga.js